<template>
  <page-markup class="membership-template-builder" :style="[customCss]">
    <div class="flex">
      <div class="w-full md:w-1/2 flex justify-center py-16 body-bg-color h-screen items-center">
        <div class="md:px-16 p-5 rounded-lg login-form-wrapper">
          <login-form
            :getThemeSettings="getThemeSettings"
            :backToHome="backToHome"
            :forgotPass="forgotPass"
            :login="login"
            :message="message"
            :spinloader="spinloader"
          >
          </login-form>
        </div>
      </div>
      <div class="w-1/2 hidden md:block relative login-form-bg">
        <login-image :getThemeSettings="getThemeSettings"></login-image>
      </div>
    </div>
  </page-markup>
</template>
<script>
import PageMarkup from './login-page-markup';
import LoginForm from '../../common/login/form';
import LoginImage from '../../common/login/just-image';

export default {
  name: 'PageTemplate',
  components: {
    PageMarkup,
    LoginForm,
    LoginImage,
  },
  props: {
    getThemeSettings: {},
    backToHome: {
      type: Function,
      default: () => {},
    },
    forgotPass: {
      type: Function,
      default: () => {},
    },
    login: {
      type: Function,
      default: () => {},
    },
    message: {
      type: Object,
      default: () => {
        return { success: true, string: '' };
      },
    },
    spinloader: {
      type: Boolean,
      default: () => {
        return false;
      },
    }
  },
  computed: {
    customCss() {
      return {
        '--template-bg-color': this.themeSettings.body_section.bg_color,
      };
    },
    themeSettings() {
      return this.getThemeSettings();
    },
  },
  data() {
    return {
      tileView: 'grid',
    };
  },
  methods: {},
  watch: {},
};
</script>
<style lang="scss">
@import '../../../../assets/css/campton_font.css';

.full-tile-hover {
  .tile-wrapper {
    position: relative;
    .relative {
      position: relative;
    }
  }
}

.body-bg-color {
  background-color: var(--template-bg-color);
}
.body-overlay-color {
  background: var(--template-overlay-color);
}
.login-form-bg img {
  position: fixed;
  object-fit: cover;
  max-width: 50%;
}
.body-overlay-color {
  height: 100vh;
  max-width: 100%;
}
.custom-scrollbars {
  .login-form-bg img {
    position: relative;
    max-width: 100%;
    height: 100vh;
  }
}
.login-form-wrapper {
  width: 528px;
  max-width: 100%;
  .text-sm {
    font-size: 14px;
  }
}
</style>
